import type { ReactNode, JSX} from "react";
import { cn } from "./cn";
import { IconBox } from "./IconBox";

export interface LinkedItemProps {
  /** Icon element */
  readonly icon: ReactNode;
  /** Label text */
  readonly title: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * An item row with a small icon box and a label.
 * Used for linked items in task cards, references, etc.
 */
export function LinkedItem({ icon, title, className }: LinkedItemProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-2 text-sm text-content-secondary", className)}>
      <IconBox size="sm">{icon}</IconBox>
      {title}
    </div>
  );
}
